module.exports = __webpack_public_path__ + "static/media/bground2.839907f8.png";